import { TranslatedText } from "@/components/common/text";

export const TitleButton = ({ type, editMode, setEditMode }) => {
    return (
        <button
            onClick={type === editMode ? () => setEditMode(null) : () => setEditMode(type)}
            className="text-cm-accent text-base font-medium"
        >
            {type === editMode ? <TranslatedText text="Cancel" /> : <TranslatedText text="Edit" />}
        </button>
    );
};
